export default defineNuxtRouteMiddleware(() => {
  const { $pinia } = useNuxtApp();
  const appStore = useAppStore($pinia);
  appStore.floorAdActive = false;
});
